import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * The page's top bar: the breadcrumb back to the section the page belongs to,
 * the page's own name after it, and the page's actions at the far end. It
 * sticks to the top of the main column (styles/page.css).
 */
export function TopBar({
  parent,
  here,
  actions,
}: {
  parent: { to: string; label: ReactNode };
  here?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="topbar">
      <div className="breadcrumb">
        <Link className="link" to={parent.to}>
          {parent.label}
        </Link>
        {here != null ? (
          <>
            {' '}
            <span className="crumb-slash">/</span> <span className="crumb-here">{here}</span>
          </>
        ) : null}
      </div>
      {actions ? <div className="topbar-actions">{actions}</div> : null}
    </div>
  );
}
